import RoleAuthorization from '@/components/Role/authorization'

let RoleRouter = [{
  path: '/role/authorization',
  name: 'RoleAuthorization',
  component: RoleAuthorization
}]

export default RoleRouter


// WEBPACK FOOTER //
// ./src/components/Role/router.js